import type { APIRequestBody, APIResponse } from './base-fetch';
import { get, post, remove } from './base-fetch';

export type CreateUserApiKeyPayload =
  APIRequestBody<'/api/v4/users/me/api-keys/create'>;

export type CreateUserApiKeyResponse =
  APIResponse<'/api/v4/users/me/api-keys/create'>;

export type UserApiKey = APIResponse<'/api/v4/users/me/api-keys'>[number];

export const fetchUserApiKeys = () =>
  get<UserApiKey[]>('/v4/users/me/api-keys');

export const createUserApiKey = (data: CreateUserApiKeyPayload) =>
  post<CreateUserApiKeyResponse>('/v4/users/me/api-keys/create', data);

export const deleteUserApiKey = (id: string) =>
  remove<void>(`/v4/users/me/api-keys/${id}`);
